var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIslandFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 416,
    viewBox: "0 0 593 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.749 393.871H567.105C603.914 361.974 565.547 314.265 555.074 303.87C521.503 270.496 547.081 260.62 533.698 239.036C521.483 219.312 516.216 242.456 502.217 231.267C486.498 218.71 516.81 169.305 497.811 151.688C479.898 135.11 462.375 166.351 432.145 163.725C396.749 160.661 376.992 136.04 349.098 171.986C341.986 181.178 324.381 208.561 306.12 212.747C271.647 220.653 243.835 185.418 234.797 181.315C189.503 160.77 171.016 238.626 212.724 295.937C227.706 316.536 137.691 316.098 165.749 393.871Z",
    fill: "#E4F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.594 124.71L299.444 126.015L303.362 126.465L303.512 125.16L299.594 124.71Z",
    fill: "#7760DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.242 123.505L289.091 124.81L294.288 125.407L294.438 124.102L289.242 123.505Z",
    fill: "#7760DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.117 122.463L279.967 123.769L283.884 124.219L284.035 122.914L280.117 122.463Z",
    fill: "#7760DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.319 256.006L313.48 388.002L304.99 388.851L287.051 257.84L305.319 256.006Z",
    fill: "#FFA41F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.807 304.064V388.276H270.29L263.963 304.064H278.807Z",
    fill: "#FFA41F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.332 304.612H263.991L262.375 282.991L260.458 257.265H305.401L307.318 288.163L308.332 304.612Z",
    fill: "#70CBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M307.318 288.163L262.375 282.991L260.458 257.265H305.401L307.318 288.163Z",
    fill: "#23ACFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M309.208 392.546C311.568 392.546 313.48 390.634 313.48 388.276C313.48 385.918 311.568 384.007 309.208 384.007C306.848 384.007 304.936 385.918 304.936 388.276C304.936 390.634 306.848 392.546 309.208 392.546Z",
    fill: "#FFA41F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M264.374 230.8H277.876H294.912L296.555 232.086C302.087 236.383 305.346 243.006 305.346 250.04V256.608C305.346 261.671 301.238 265.804 296.144 265.804H269.633C264.566 265.804 260.43 261.698 260.43 256.608V247.631C260.43 241.774 261.772 236.027 264.374 230.8Z",
    fill: "#70CBFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M270.29 388.276H278.835V394.188H266.866C265.853 394.188 265.031 393.367 265.031 392.354C265.031 391.697 265.388 391.095 265.963 390.767L270.29 388.276Z",
    fill: "#1A2858"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M328.9 205.293C326.599 202.747 324.326 200.284 323.86 196.261C322.737 186.381 327.092 185.505 325.558 175.68C324.025 165.855 316.74 167.087 315.206 157.262C315.014 156.003 314.987 154.853 315.124 153.841C315.754 152.445 316.247 151.022 316.603 149.516C316.657 149.27 316.74 148.996 316.767 148.723C317.315 146.095 317.479 143.331 317.15 140.512C315.534 126.5 302.854 116.428 288.831 118.043C274.809 119.658 264.73 132.329 266.346 146.342C266.675 149.161 267.442 151.815 268.564 154.251C268.674 154.497 268.784 154.716 268.893 154.963C269.578 156.331 270.399 157.645 271.331 158.849C271.687 159.807 271.933 160.929 272.015 162.188C272.755 172.095 265.387 172.56 266.127 182.468C266.866 192.375 271.303 192.265 272.454 202.118C272.919 206.114 271.248 209.042 269.605 212.053C267.962 215.063 266.319 218.128 266.812 222.37C268.208 234.604 279.273 243.362 291.488 241.939L314.329 239.311C326.572 237.915 335.336 226.859 333.912 214.653C333.473 210.465 331.173 207.865 328.9 205.293Z",
    fill: "#1A2858"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M309.153 176.474L277.657 172.615C272.837 172.013 268.482 175.571 268.099 180.442L264.456 228.063C263.416 236.438 269.386 244.046 277.739 245.059C286.12 246.099 293.734 240.132 294.747 231.785L313.398 183.59C314.631 180.388 312.549 176.884 309.153 176.474Z",
    fill: "#70CBFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M264.374 229.869H277.876H294.912L296.555 231.155C302.087 235.452 305.346 242.075 305.346 249.109V256.307L306.278 271.578H260.43V246.701C260.43 240.844 261.772 235.096 264.374 229.869Z",
    fill: "#70CBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.526 142.893C222.334 142.975 223.731 144.508 223.649 146.342C223.566 148.148 222.033 149.544 220.198 149.462C218.39 149.38 216.993 147.847 217.075 146.013C217.185 144.18 218.719 142.784 220.526 142.893Z",
    fill: "#FFA41F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.333 140.047C226.524 139.582 226.634 139.089 226.661 138.569C226.771 136.024 224.826 133.889 222.279 133.752C219.732 133.643 217.596 135.586 217.459 138.131L217.075 145.986L223.402 147.354L226.333 140.047Z",
    fill: "#FFA41F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.298 183.289L223.21 144.481L217.377 147.464L235.261 188.899L246.298 183.289Z",
    fill: "#FFA41F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.969 190.322L274.206 203.076C271.769 205.512 267.989 206.305 264.648 204.827C260.348 202.884 258.431 197.849 260.376 193.552C260.814 192.594 261.416 191.745 262.128 191.034L274.891 178.28L286.969 190.322Z",
    fill: "#70CBFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.134 180.169C284.723 175.489 280.56 172.013 275.877 172.424C275.494 172.451 275.138 172.533 274.782 172.615L243.998 179.43L226.333 149.735L219.787 153.074L235.261 188.927C236.356 191.444 238.904 192.868 241.505 192.649H241.588H241.615L277.383 189.474C282.094 189.009 285.572 184.876 285.134 180.169Z",
    fill: "#70CBFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.997 155.072L281.437 172.478C280.643 176.392 283.162 180.196 287.079 180.99C290.995 181.783 294.802 179.265 295.596 175.352L299.157 157.946L284.997 155.072Z",
    fill: "#FFA41F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M300.636 154.005L297.431 153.348L298.746 146.917L301.95 147.573C303.73 147.929 304.881 149.681 304.525 151.433C304.141 153.212 302.388 154.361 300.636 154.005Z",
    fill: "#FFA41F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M279.602 130.304L303.785 135.23L297.431 166.403L282.423 163.337C276.397 162.106 272.673 156.085 274.261 150.146L279.602 130.304Z",
    fill: "#FFA41F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M301.293 147.436L301.923 147.573L305.702 128.99L286.558 125.077C281.492 124.037 276.562 127.321 275.521 132.357L275.439 132.712L276.096 132.849C281.574 133.971 286.531 136.845 290.228 141.032C293.131 144.344 297.02 146.561 301.293 147.436Z",
    fill: "#1A2858"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M277.356 187.859L279.218 172.779L302.197 175.598L277.356 187.859Z",
    fill: "#FFA41F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M326.271 265.557C326.709 263.806 325.613 262.027 323.86 261.589C322.108 261.151 320.327 262.246 319.889 263.997C319.451 265.749 320.547 267.528 322.299 267.966C324.052 268.404 325.832 267.309 326.271 265.557Z",
    fill: "#FFA41F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M330.625 260.795C331.118 260.768 331.638 260.795 332.131 260.905C334.596 261.507 336.103 263.998 335.5 266.461C334.898 268.924 332.405 270.429 329.94 269.827L322.272 267.966L322.737 261.507L330.625 260.795Z",
    fill: "#FFA41F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M320.82 219.552L326.462 264.353L320.026 265.585L308.66 221.878L320.82 219.552Z",
    fill: "#FFA41F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.901 153.403C285.49 155.346 283.573 156.605 281.628 156.195C279.684 155.784 278.424 153.868 278.835 151.925L285.901 153.403Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M264.456 187.777L269.879 182.358L264.456 187.777Z",
    fill: "#70CBFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M269.417 181.895L263.995 187.314L264.924 188.243L270.347 182.824L269.417 181.895Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M271.577 205.594C270.509 206.032 269.359 206.251 268.181 206.251C266.866 206.251 265.607 205.977 264.402 205.43C260.704 203.76 258.65 199.956 259.034 196.124L271.577 205.594Z",
    fill: "#70CBFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M268.181 206.908C266.784 206.908 265.415 206.607 264.128 206.032C260.266 204.281 257.938 200.285 258.376 196.07L259.691 196.206C259.307 199.874 261.334 203.35 264.675 204.855C266.784 205.813 269.167 205.868 271.331 205.02L271.824 206.251C270.646 206.662 269.414 206.908 268.181 206.908Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M304.935 388.276H313.48V394.188H301.512C300.499 394.188 299.677 393.367 299.677 392.354C299.677 391.697 300.033 391.095 300.608 390.767L304.935 388.276Z",
    fill: "#1A2858"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M306.263 260.741L304.951 260.822L309.359 332.199L310.671 332.118L306.263 260.741Z",
    fill: "#1A2858"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M310.989 336.898L309.677 336.979L310.108 343.973L311.42 343.892L310.989 336.898Z",
    fill: "#1A2858"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M316.301 183.836C316.247 183.48 316.192 183.097 316.082 182.741C314.905 178.171 310.221 175.461 305.675 176.638C301.101 177.815 298.39 182.495 299.567 187.038L318.465 259.673L325.668 258.305L316.301 183.836Z",
    fill: "#70CBFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M508.427 336.304C508.427 320.677 462.36 280.911 462.36 250.067C462.36 232.989 475.479 219.579 497.828 227.57C497.828 227.57 466.962 131.809 526.064 116.237C551.179 109.614 571.145 148.723 550.795 170.535C529.159 193.743 525.599 218.539 538.416 212.381C568.707 197.821 573.363 233.974 540.279 280.117C530.638 293.528 508.427 324.098 508.427 336.304C508.427 356.201 508.427 369.857 508.427 336.304Z",
    fill: "#88D3FE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M307.565 404.669H37.7404V405.983H307.565V404.669Z",
    fill: "#23ACFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M456.253 414.686H209.023V416H456.253V414.686Z",
    fill: "#23ACFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M593 394.188H0V395.501H593V394.188Z",
    fill: "#23ACFA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M334.952 394.188H154.303V395.501H334.952V394.188Z",
    fill: "#1A2858"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M355.63 394.188H346.099V395.501H355.63V394.188Z",
    fill: "#1A2858"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M541.429 394.188H518.368V395.501H541.429V394.188Z",
    fill: "#1A2858"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M506.318 394.188H427.496V395.501H506.318V394.188Z",
    fill: "#1A2858"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M145.183 394.188H129.873V395.501H145.183V394.188Z",
    fill: "#1A2858"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M121.739 394.188H88.9006V395.501H121.739V394.188Z",
    fill: "#1A2858"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1907 394.188H75.2068V395.501H82.1907V394.188Z",
    fill: "#1A2858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9202 394.188H18.4867V395.501H71.9202V394.188Z",
    fill: "#1A2858"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M295.925 404.669H285.216V405.983H295.925V404.669Z",
    fill: "#23ACFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M200.095 414.686H182.704V416H200.095V414.686Z",
    fill: "#23ACFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M484.736 414.686H476.41V416H484.736V414.686Z",
    fill: "#23ACFA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M480.162 268.595H120.041V275.164H480.162V268.595Z",
    fill: "#1A2858"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M142.143 275.136H135.569V394.16H142.143V275.136Z",
    fill: "#E4F5FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M468.906 275.136H462.333V394.16H468.906V275.136Z",
    fill: "#70CBFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M166.052 381.325V377.384L216.309 373.442V381.325H166.052Z",
    fill: "#E4F5FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M223.566 320.348H215.679V381.324H223.566V320.348Z",
    fill: "#23ACFA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M273.166 381.325V377.384L222.882 373.442V381.325H273.166Z",
    fill: "#23ACFA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M223.539 322.319V335.209L215.679 334.306V322.319H223.539Z",
    fill: "#70CBFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M277.958 310.441H245.476C241.341 310.441 237.917 307.239 237.616 303.134L232.111 226.394C231.892 223.274 229.29 220.92 226.223 220.92H166.518C166.381 220.92 166.244 220.92 166.079 220.92C162.82 221.166 160.383 223.985 160.602 227.242L166.107 303.982C166.846 314.273 175.419 322.264 185.744 322.264H197.192H245.449H277.931C281.19 322.264 283.847 319.609 283.847 316.353C283.874 313.096 281.218 310.441 277.958 310.441Z",
    fill: "#FFE159"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M177.911 303.134L172.406 226.394C172.159 223.137 169.339 220.701 166.079 220.92C162.82 221.166 160.383 223.985 160.602 227.242L166.107 303.982C166.846 314.273 175.419 322.264 185.744 322.264H224.799C228.058 322.264 230.715 319.609 230.715 316.353C230.715 313.096 228.058 310.441 224.799 310.441H185.771C181.636 310.441 178.212 307.239 177.911 303.134Z",
    fill: "#FFA41F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.147 394.188C171.87 394.188 174.077 391.983 174.077 389.262C174.077 386.541 171.87 384.335 169.147 384.335C166.424 384.335 164.217 386.541 164.217 389.262C164.217 391.983 166.424 394.188 169.147 394.188Z",
    fill: "#1A2858"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M219.595 394.188C222.318 394.188 224.525 391.983 224.525 389.262C224.525 386.541 222.318 384.335 219.595 384.335C216.872 384.335 214.665 386.541 214.665 389.262C214.665 391.983 216.872 394.188 219.595 394.188Z",
    fill: "#1A2858"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M270.071 394.188C272.793 394.188 275.001 391.983 275.001 389.262C275.001 386.541 272.793 384.335 270.071 384.335C267.348 384.335 265.141 386.541 265.141 389.262C265.141 391.983 267.348 394.188 270.071 394.188Z",
    fill: "#1A2858"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M224.662 231.922H180.759V233.236H224.662V231.922Z",
    fill: "#FFA41F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M225.429 242.951H181.526V244.265H225.429V242.951Z",
    fill: "#FFA41F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M226.223 253.98H182.32V255.294H226.223V253.98Z",
    fill: "#FFA41F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M227.017 265.01H183.115V266.324H227.017V265.01Z",
    fill: "#FFA41F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M227.811 276.039H183.909V277.353H227.811V276.039Z",
    fill: "#FFA41F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M228.606 287.069H184.703V288.382H228.606V287.069Z",
    fill: "#FFA41F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M229.4 298.098H185.497V299.412H229.4V298.098Z",
    fill: "#FFA41F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M232.604 311.098H185.771C181.307 311.098 177.582 307.622 177.254 303.189L172.105 231.539L173.419 231.457L178.568 303.079C178.842 306.829 181.992 309.784 185.771 309.784H232.604V311.098Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M238.383 309.784H235.644V311.098H238.383V309.784Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M224.196 322.319H222.882V360.771H224.196V322.319Z",
    fill: "#1A2858"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M224.196 362.851H222.882V365.369H224.196V362.851Z",
    fill: "#1A2858"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M191.194 380.668H166.052V381.981H191.194V380.668Z",
    fill: "#1A2858"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M199.876 380.668H195.275V381.981H199.876V380.668Z",
    fill: "#1A2858"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M273.166 380.668H210.393V381.981H273.166V380.668Z",
    fill: "#1A2858"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M265.661 321.607H261.964V322.921H265.661V321.607Z",
    fill: "#1A2858"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M248.517 322.921H185.771C175.145 322.921 166.216 314.628 165.477 304.037L162.382 260.768L163.697 260.686L166.792 303.955C167.504 313.862 175.857 321.635 185.771 321.635H248.517V322.921Z",
    fill: "#1A2858"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M161.697 251.408L159.972 227.269C159.725 223.739 162.327 220.646 165.806 220.29V220.263H166.545H189.879V221.577H166.572C166.408 221.577 166.299 221.577 166.189 221.577C163.286 221.796 161.122 224.313 161.314 227.187L163.039 251.326L161.697 251.408Z",
    fill: "#1A2858"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M232.166 236.164L231.454 226.421C231.344 224.833 230.523 223.383 229.181 222.48L229.92 221.385C231.591 222.534 232.604 224.313 232.741 226.311L233.453 236.054L232.166 236.164Z",
    fill: "#1A2858"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M233.45 236.071L232.139 236.165L232.998 248.148L234.309 248.054L233.45 236.071Z",
    fill: "#1A2858"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M234.553 251.299L233.241 251.393L234.852 273.859L236.163 273.765L234.553 251.299Z",
    fill: "#1A2858"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M236.519 278.696L235.207 278.79L235.407 281.575L236.718 281.481L236.519 278.696Z",
    fill: "#1A2858"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M274.727 309.784H241.588V311.098H274.727V309.784Z",
    fill: "#1A2858"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M277.958 322.921H268.756V321.607H277.958C280.862 321.607 283.217 319.254 283.217 316.353C283.217 313.452 280.862 311.098 277.958 311.098H274.727V309.784H277.958C281.574 309.784 284.531 312.74 284.531 316.353C284.531 319.965 281.574 322.921 277.958 322.921Z",
    fill: "#1A2858"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M455.787 281.705H393.809V394.16H455.787V281.705Z",
    fill: "#E4F5FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.569 275.136H142.143V292.652L135.569 291.886V275.136Z",
    fill: "#23ACFA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M393.809 281.705H455.76V325.685L393.809 318.569V281.705Z",
    fill: "#70CBFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M468.906 275.136V327.19L462.333 326.451V275.136H468.906Z",
    fill: "#23ACFA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M449.871 388.276H399.724V287.616H449.871V388.276ZM401.012 386.962H448.529V288.93H401.012V386.962Z",
    fill: "#1A2858"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M424.784 328.806C422.977 328.806 421.498 327.328 421.498 325.521C421.498 323.715 422.977 322.237 424.784 322.237C426.592 322.237 428.071 323.715 428.071 325.521C428.071 327.328 426.592 328.806 424.784 328.806ZM424.784 323.551C423.689 323.551 422.812 324.426 422.812 325.521C422.812 326.616 423.689 327.492 424.784 327.492C425.88 327.492 426.756 326.616 426.756 325.521C426.756 324.426 425.88 323.551 424.784 323.551Z",
    fill: "#1A2858"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M424.784 303.955C422.977 303.955 421.498 302.477 421.498 300.671C421.498 298.864 422.977 297.386 424.784 297.386C426.592 297.386 428.071 298.864 428.071 300.671C428.071 302.505 426.592 303.955 424.784 303.955ZM424.784 298.728C423.689 298.728 422.812 299.603 422.812 300.698C422.812 301.793 423.689 302.669 424.784 302.669C425.88 302.669 426.756 301.793 426.756 300.698C426.756 299.603 425.88 298.728 424.784 298.728Z",
    fill: "#1A2858"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M424.784 353.628C422.977 353.628 421.498 352.15 421.498 350.344C421.498 348.538 422.977 347.06 424.784 347.06C426.592 347.06 428.071 348.538 428.071 350.344C428.071 352.178 426.592 353.628 424.784 353.628ZM424.784 348.401C423.689 348.401 422.812 349.277 422.812 350.371C422.812 351.466 423.689 352.342 424.784 352.342C425.88 352.342 426.756 351.466 426.756 350.371C426.756 349.277 425.88 348.401 424.784 348.401Z",
    fill: "#1A2858"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M424.784 378.479C422.977 378.479 421.498 377.001 421.498 375.194C421.498 373.388 422.977 371.91 424.784 371.91C426.592 371.91 428.071 373.388 428.071 375.194C428.071 377.001 426.592 378.479 424.784 378.479ZM424.784 373.224C423.689 373.224 422.812 374.1 422.812 375.194C422.812 376.289 423.689 377.165 424.784 377.165C425.88 377.165 426.756 376.289 426.756 375.194C426.756 374.1 425.88 373.224 424.784 373.224Z",
    fill: "#1A2858"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M449.187 362.112H400.354V363.426H449.187V362.112Z",
    fill: "#1A2858"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M449.187 337.289H400.354V338.603H449.187V337.289Z",
    fill: "#1A2858"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M449.187 312.439H400.354V313.753H449.187V312.439Z",
    fill: "#1A2858"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M405.038 265.968H373.514V268.595H405.038V265.968Z",
    fill: "#23ACFA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M392.631 268.595H417.581L415.609 217.854H394.603L392.631 268.595Z",
    fill: "#23ACFA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M392.677 249.172L392.165 262.437L393.479 262.487L393.991 249.223L392.677 249.172Z",
    fill: "#23ACFA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M416.924 268.623L414.979 218.512H405.092V217.198H416.239L418.239 268.568L416.924 268.623Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M350.581 252.403H456.791V178.591H350.581V252.403Z",
    fill: "#E4F5FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M454.171 181.209H353.22V242.103H454.171V181.209Z",
    fill: "#1A2858"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M454.171 227.543V242.13H360.615L363.901 241.61L454.171 227.543Z",
    fill: "#1A2858"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M344.522 196.062L354.831 198.144L356.497 189.908L346.188 187.826L344.522 196.062Z",
    fill: "#23ACFA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M345.251 210.323H355.768V201.921H345.251V210.323Z",
    fill: "#FFE159"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M344.982 222.914L355.38 221.34L354.121 213.032L343.722 214.607L344.982 222.914Z",
    fill: "#FFC359"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M536.636 360.771L534.281 372.868L530.09 394.16H486.735L481.367 366.765L480.19 360.771H536.636Z",
    fill: "#70CBFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M536.636 360.771L534.281 372.868L481.367 366.765L480.19 360.771H536.636Z",
    fill: "#23ACFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M153.07 274.479H120.041V275.793H153.07V274.479Z",
    fill: "#1A2858"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M480.162 274.479H407.01V275.793H480.162V274.479Z",
    fill: "#1A2858"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M394.466 325.685H393.151V281.048H437.465V282.361H394.466V325.685Z",
    fill: "#1A2858"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M449.214 281.048H442.312V282.361H449.214V281.048Z",
    fill: "#1A2858"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M394.466 334.662H393.151V341.97H394.466V334.662Z",
    fill: "#1A2858"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M456.417 355.325H455.103V394.187H456.417V355.325Z",
    fill: "#1A2858"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M469.563 341.969H468.249V370.131H469.563V341.969Z",
    fill: "#1A2858"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M469.563 275.136H468.249V317.639H469.563V275.136Z",
    fill: "#1A2858"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 277.9H141.485V300.643H142.8V277.9Z",
    fill: "#1A2858"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 307.211H141.485V338.603H142.8V307.211Z",
    fill: "#1A2858"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 343.064H141.485V347.224H142.8V343.064Z",
    fill: "#1A2858"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M509.057 356.2H507.742V298.755C507.742 208.549 519.683 161.285 519.793 160.819L521.052 161.148C520.943 161.613 509.057 208.714 509.057 298.755V356.2Z",
    fill: "#1A2858"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M509.057 289.368H507.742C507.742 265.393 517.163 246.947 536.554 232.962L537.321 234.029C518.314 247.741 509.057 265.858 509.057 289.368Z",
    fill: "#1A2858"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M518.314 360.114H476.301V361.428H518.314V360.114Z",
    fill: "#1A2858"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M526.229 360.114H522.504V361.428H526.229V360.114Z",
    fill: "#1A2858"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M540.525 360.114H529.844V361.428H540.525V360.114Z",
    fill: "#1A2858"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M407.037 251.736H350.618V253.05H407.037V251.736Z",
    fill: "#23ACFA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M422.155 251.736H413.528V253.05H422.155V251.736Z",
    fill: "#23ACFA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M415.637 177.924H350.618V179.238H415.637V177.924Z",
    fill: "#1A2858"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M456.801 177.924H444.613V179.238H456.801V177.924Z",
    fill: "#1A2858"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M393.809 274.479H243.121V275.793H393.809V274.479Z",
    fill: "#1A2858"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M196.809 191.472C182.786 202.857 150.195 196.289 168.791 166.977C187.387 137.666 219.486 173.053 196.809 191.472Z",
    fill: "#E4F5FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M406.651 41.834H404.282V51.3065H406.651V41.834Z",
    fill: "#FFA41F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M406.651 99.4546H404.282V108.927H406.651V99.4546Z",
    fill: "#FFA41F"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M389.815 45.7662L387.876 46.8853L392.659 55.1634L394.598 54.0443L389.815 45.7662Z",
    fill: "#FFA41F"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M418.593 95.5308L416.654 96.6499L421.437 104.928L423.376 103.809L418.593 95.5308Z",
    fill: "#FFA41F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M377.133 57.6733L376.013 59.6116L384.297 64.3909L385.417 62.4526L377.133 57.6733Z",
    fill: "#FFA41F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M426.963 86.4071L425.843 88.3455L434.127 93.1248L435.247 91.1865L426.963 86.4071Z",
    fill: "#FFA41F"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M381.384 74.1963H371.908V76.5644H381.384V74.1963Z",
    fill: "#FFA41F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M439.025 74.1963H429.55V76.5644H439.025V74.1963Z",
    fill: "#FFA41F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M384.35 86.424L376.065 91.2024L377.185 93.1409L385.469 88.3625L384.35 86.424Z",
    fill: "#FFA41F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M434.131 57.6762L425.846 62.4546L426.966 64.3931L435.251 59.6147L434.131 57.6762Z",
    fill: "#FFA41F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M392.653 95.563L387.871 103.842L389.811 104.961L394.593 96.6818L392.653 95.563Z",
    fill: "#FFA41F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M421.418 45.7497L416.636 54.0288L418.576 55.1477L423.358 46.8686L421.418 45.7497Z",
    fill: "#FFA41F"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M297.623 267.281H248.517V268.595H297.623V267.281Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M454.171 241.501H376.226V242.814H454.171V241.501Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M400.053 181.209H353.22V182.522H400.053V181.209Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M163.779 218.977L141.978 217.088C140.308 216.952 138.692 216.349 137.322 215.392L136.802 214.981L115.083 197.821L115.905 196.781L137.24 213.613L137.706 213.968C138.993 214.981 140.499 215.583 142.143 215.72H142.197L163.943 217.608L163.779 218.977Z",
    fill: "#1A2858"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M167.068 217.928L166.955 219.237L175.277 219.958L175.39 218.649L167.068 217.928Z",
    fill: "#1A2858"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M192.399 212.436L188.62 211.341L147.867 199.627L121.602 169.03C121.054 168.4 120.451 167.798 119.767 167.251C114.07 162.763 105.826 163.72 101.335 169.413C96.8432 175.106 97.8017 183.343 103.498 187.832L137.185 214.434L137.268 214.488C138.582 215.528 140.225 216.24 142.033 216.377C142.06 216.377 142.088 216.377 142.088 216.377L193.495 220.838L194.919 213.12L192.399 212.436Z",
    fill: "#1A2858"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4351 172.588C85.9702 165.773 78.4386 162.27 71.619 164.733C70.7974 165.034 70.0305 165.39 69.3185 165.828L32.4545 187.996C28.3464 190.459 26.8948 195.741 29.2228 199.956C29.4966 200.476 29.8527 200.941 30.2087 201.379L59.1302 235.918L61.6499 238.928L63.3479 240.981L69.8114 236.547L49.9279 200.476L80.5474 189.364C87.3944 186.929 90.9 179.402 88.4351 172.588Z",
    fill: "#1A2858"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M112.016 164.459L76.0832 163.967C70.8248 163.885 66.5797 168.236 66.7714 173.463L69.072 238.901L69.4006 247.85L69.428 248.288C69.5923 253.05 73.4814 256.854 78.2742 256.936L107.333 257.347C112.098 257.402 116.097 253.707 116.398 248.945L116.425 248.507L117.001 239.558L121.109 174.23C121.383 168.975 117.247 164.514 112.016 164.459Z",
    fill: "#1A2858"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6171 256.324L82.599 257.638L96.1272 257.824L96.1453 256.51L82.6171 256.324Z",
    fill: "#1A2858"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M105.06 164.377L104.868 178.198L101.17 192.074L96.0216 211.532L91.4204 191.937L84.8748 164.104L105.06 164.377Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M116.398 248.507C116.453 243.553 112.509 239.503 107.552 239.421C102.595 239.366 98.5412 243.307 98.4591 248.261V248.288L97.6922 303.845L96.5419 387.373C96.4871 390.438 98.952 392.956 102.019 392.983C105.087 393.038 107.607 390.575 107.634 387.51C107.634 387.482 107.634 387.455 107.634 387.428L112.892 304.064L116.316 249.465C116.371 249.136 116.371 248.808 116.398 248.507Z",
    fill: "#1A2858"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M109.888 330.847L108.13 358.679L109.442 358.762L111.2 330.929L109.888 330.847Z",
    fill: "#1A2858"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M107.881 362.686L106.777 380.167L108.089 380.25L109.193 362.769L107.881 362.686Z",
    fill: "#1A2858"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M101.17 192.074L96.0216 211.533L91.4204 191.937L95.9942 167.388H97.3088L101.17 192.074Z",
    fill: "#FFA41F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8464 164.066L101.25 164.291L101.494 146.531L85.0908 146.305L84.8464 164.066Z",
    fill: "#FFA41F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M113.221 394.161H96.5692V387.592H107.661L114.015 391.068C114.536 391.369 114.864 391.916 114.864 392.518C114.864 393.422 114.125 394.161 113.221 394.161Z",
    fill: "#1A2858"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M108.948 133.506L106.566 133.752L104.84 117.742L107.223 117.496C111.66 117.03 115.631 120.205 116.097 124.639C116.59 129.072 113.385 133.041 108.948 133.506Z",
    fill: "#1A2858"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0643 150.748L85.1212 151.377C81.8347 151.733 78.9042 149.352 78.5481 146.095L77.8361 139.609L89.6949 138.323L91.0643 150.748Z",
    fill: "#1A2858"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M107.305 133.287L100.869 133.971L98.6508 113.363L104.402 112.734C108.346 112.323 111.852 115.142 112.29 119.083L113.057 126.144C113.44 129.702 110.866 132.904 107.305 133.287Z",
    fill: "#1A2858"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M107.442 155.072L86.381 157.344L83.834 133.643C83.0671 126.445 88.2708 119.959 95.5012 119.193C102.458 118.454 108.812 123.298 109.88 130.222L112.701 148.258C113.221 151.596 110.838 154.716 107.442 155.072Z",
    fill: "#FFA41F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5314 117.769L89.3116 117.578L91.7217 139.91L78.0826 141.388L76.9597 130.933C76.2202 124.365 80.9857 118.481 87.5314 117.769Z",
    fill: "#1A2858"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M84.82 142.894L88.3804 142.511L87.9969 138.953C87.7778 136.982 86.025 135.559 84.0531 135.778C82.0812 135.997 80.657 137.748 80.8761 139.719C81.0952 141.69 82.848 143.113 84.82 142.894Z",
    fill: "#FFA41F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 126.39L97.8565 127.841C92.3516 128.443 87.3944 124.447 86.7919 118.919C86.518 116.291 88.4078 113.938 91.037 113.664C93.6662 113.39 96.0216 115.279 96.2954 117.906C96.3228 118.18 96.5693 118.371 96.8432 118.344L110.345 116.893L111.359 126.39Z",
    fill: "#1A2858"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M105.799 122.204L99.0616 122.915C96.4323 123.189 94.077 121.3 93.8031 118.673C93.5292 116.045 95.419 113.692 98.0482 113.418L104.786 112.706C107.415 112.433 109.77 114.321 110.044 116.949C110.318 119.576 108.428 121.93 105.799 122.204Z",
    fill: "#1A2858"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M101.691 146.479C101.91 148.449 103.69 149.9 105.662 149.681C107.634 149.462 109.086 147.683 108.866 145.712L101.691 146.479Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1366 239.202C75.289 238.217 70.5509 241.364 69.5649 246.208C69.5375 246.345 69.5101 246.509 69.5101 246.646L48.2025 386.634C47.7369 389.644 49.8183 392.463 52.831 392.929C55.7615 393.394 58.5276 391.451 59.1028 388.55L87.1479 249.738C88.1064 244.894 84.9842 240.187 80.1366 239.202Z",
    fill: "#1A2858"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4761 254.677L79.1356 286.094L80.4244 286.353L86.7648 254.937L85.4761 254.677Z",
    fill: "#1A2858"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0808 291.347L57.6143 392.707L58.903 392.967L79.3695 291.607L78.0808 291.347Z",
    fill: "#1A2858"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5332 394.161H59.1849V387.592H48.0929L41.7389 391.068C41.2185 391.369 40.8899 391.916 40.8899 392.518C40.8899 393.422 41.6294 394.161 42.5332 394.161Z",
    fill: "#1A2858"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9763 190.032L50.9847 198.738L51.4334 199.973L75.425 191.267L74.9763 190.032Z",
    fill: "#1A2858"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M197.794 217.307C197.986 215.145 196.37 213.229 194.207 213.038C192.043 212.846 190.126 214.461 189.934 216.623C189.742 218.785 191.358 220.701 193.522 220.893C195.686 221.084 197.603 219.47 197.794 217.307Z",
    fill: "#FFA41F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M197.63 218.101C198.26 216.021 197.082 213.832 195.001 213.202C192.919 212.573 190.728 213.75 190.098 215.83C189.469 217.91 190.646 220.099 192.728 220.729C194.809 221.358 197 220.181 197.63 218.101Z",
    fill: "#FFA41F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M204.505 210.602C203.519 210.328 202.505 210.328 201.574 210.602L192.755 213.175C191.495 213.531 190.455 214.516 190.071 215.857C189.469 217.937 190.674 220.127 192.755 220.729C193.111 220.838 193.495 220.893 193.851 220.893H203.053C205.326 220.893 207.435 219.388 208.092 217.089C208.914 214.324 207.298 211.396 204.505 210.602Z",
    fill: "#FFA41F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M186.073 220.236L193.522 220.893L194.946 213.175L192.399 212.436L188.62 211.341L186.073 220.236Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M194.946 213.175L193.522 220.893L190.044 220.592L192.399 212.436L194.946 213.175Z",
    fill: "#FFA41F"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6863 209.222L67.3724 209.269L68.4193 238.918L69.7331 238.872L68.6863 209.222Z",
    fill: "#1A2858"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4195 201.743L67.1057 201.789L67.208 204.689L68.5219 204.642L68.4195 201.743Z",
    fill: "#1A2858"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M119.533 187.769L117.184 225.243L118.496 225.325L120.845 187.851L119.533 187.769Z",
    fill: "#1A2858"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M117 228.179L116.536 235.527L117.848 235.609L118.312 228.262L117 228.179Z",
    fill: "#1A2858"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0832 236.109L67.0178 234.631C64.8816 234.276 62.8549 235.726 62.4989 237.888C62.1976 239.667 63.1562 241.337 64.6899 242.075L72.961 246.044C73.3992 246.263 73.8648 246.4 74.3852 246.482C77.2609 246.947 79.9449 245.004 80.4105 242.158C80.8761 239.284 78.9315 236.574 76.0832 236.109Z",
    fill: "#FFA41F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3479 241.036L69.8114 236.602L66.1962 230.061L59.1028 235.973L61.6225 238.983L63.3479 241.036Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3478 241.036L69.8113 236.602L68.1407 233.564L61.6498 238.983L63.3478 241.036Z",
    fill: "#FFA41F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M395.945 215.364C407.804 215.364 419.362 213.859 427.551 206.497L439.245 201.817C431.056 213.339 417.499 222.535 402.299 222.535C387.099 222.535 373.542 215.008 365.353 203.486H365.517C373.378 210.848 384.059 215.364 395.945 215.364Z",
    fill: "#FFA41F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M441.6 202.145H421.854L431.713 219.196L441.6 202.145Z",
    fill: "#FFA41F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIslandFrame);
export default __webpack_public_path__ + "static/media/IslandFrame.fa4578535634cf98a4b9209341810bd9.svg";
export { ForwardRef as ReactComponent };